import React from 'react';
import { cx } from 'linaria';
import { Divider, LogoLemanaPro, Typography } from 'fronton-react';
import { PackageIcon, TruckIcon, LockSimpleIcon } from '@fronton/icons-react';
import { useTranslation } from 'react-i18next';
import {
  address,
  delivery,
  deliveryIcon,
  deliveryRow,
  deliveryRowDisable,
  deliveryRowWithIcon,
  deliveryText,
} from './styles';

export const DATA_QA_SET_DELIVERY = 'set-delivery';

export function SetDelivery() {
  const { t } = useTranslation();

  return (
    <div data-qa={DATA_QA_SET_DELIVERY} className={delivery}>
      <Divider />
      <Typography className={address} size="caption" variant="minor" color="text-primary">
        {t('product-info.set.delivery-address')}
      </Typography>
      <div className={deliveryRow}>
        <LogoLemanaPro className={deliveryIcon} logoSize="mini" type="Vertical" />
        <Typography className={deliveryText} size="body_long" variant="s" color="text-primary">
          {t('product-info.set.pickup')}
        </Typography>
      </div>
      <div className={cx(deliveryRow, deliveryRowDisable)}>
        <PackageIcon className={deliveryIcon} type="outline" size="l" color="text-primary" />
        <div className={deliveryRowWithIcon}>
          <Typography className={deliveryText} size="body_long" variant="s" color="text-primary">
            {t('product-info.set.delivery-point')}
          </Typography>
          <LockSimpleIcon className={deliveryIcon} type="outline" size="l" color="text-primary" />
        </div>
      </div>
      <div className={deliveryRow}>
        <TruckIcon className={deliveryIcon} type="outline" size="l" color="text-primary" />
        <Typography className={deliveryText} size="body_long" variant="s" color="text-primary">
          {t('product-info.set.delivery')}
        </Typography>
      </div>
    </div>
  );
}
